export default "__VITE_ASSET__CgWHrFJS__"